import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, IconButton, Modal, Snackbar, TextField } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import { Alert, Autocomplete, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React, { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { getCategoryAction } from "../../../redux/coupon/GetCategoryRTK";
import { LinkCategoryAction } from "../../../redux/coupon/LinkCategoryRTk";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  background: "#fff",
  boxShadow: 24,
  padding: 20,
};

// schema
const schema = yup.object({ categoryname: yup.string().required() }).required();

export default function LinkCategory({
  linkCategory,
  setLinkCategory,
  propsData,
}) {
  // state
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });
  const dispatchRTK = useDispatch();
  const getCategorySelector = useSelector((state) => state.getCategory);
  const { data: categoryData } = getCategorySelector;
  const linkCategorySelector = useSelector((state) => state.linkCategory);
  const { data, status, message, error } = linkCategorySelector;
  const [snackbarState, setSnackbarState] = useState(false)

  // functions------>
  const handleClose = () => {
    setLinkCategory(false);
  };
  const linkUnlinkFunc = (data) => {
    const foundCateId = categoryData?.find(
      (element) => element?.name == data?.categoryname
    );
    dispatchRTK(LinkCategoryAction({ ...propsData, is_deleted: false, catId: foundCateId?._id, })
    );
    setSnackbarState(true)
  };
  const snackBarClose = () => {
    setSnackbarState(false)
    setLinkCategory(false)
  }


  // useEffect
  useEffect(() => {
    dispatchRTK(getCategoryAction(propsData));
  }, [dispatchRTK]);

  return (
    <>
      <Modal
        open={linkCategory}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box style={style}>
          <Stack
            direction="row"
            sx={{ diplay: "flex", justifyContent: "space-between" }}
          >
            <Typography variant="h5">Link</Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <form onSubmit={handleSubmit(linkUnlinkFunc)}>
            <Autocomplete
              disablePortal
              options={
                categoryData.map((items) => items?.name)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Category"
                  {...register("categoryname")}
                  error={errors?.categoryname?.message}
                  helperText={errors?.categoryname?.message}
                />
              )}
            />
            <Stack direction="row" sx={{ mt: 2 }} spacing={2}>
              <Button variant="contained" color="primary" type="submit">
                Link
              </Button>
              <Button variant="contained" color="error" onClick={handleClose}>
                Close
              </Button>
            </Stack>
          </form>
        </Box>
      </Modal>


      {/* snackbar */}
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbarState} autoHideDuration={1000} onClose={snackBarClose}>
        <Alert onClose={snackBarClose} severity={status == 200 ? "success" : "error"} sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    </>
  );
}
